import state from './module-taxregishistory-state';
import actions from './module-taxregishistory-actions';
import mutations from './module-taxregishistory-mutations';
import getters from './module-taxregishistory-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
